import { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import withTheme from 'core/hocs/withTheme';
import withBreakpoint from 'core/hocs/withBreakpoint';

import { Desktop } from 'core/components/breakpoint';
import CaptionCredits from 'core/components/CaptionCredits';
import EmptyWrapper from 'core/components/EmptyWrapper';

import themePropTypes from 'core/utils/prop-types/theme';

import { TopicContentMaxWidth } from '../../Wrappers';
import Camera from './../Icons/Camera.svg';

import styles from './index.styl';


class ImageInfo extends PureComponent {
  static propTypes = {
    caption: PropTypes.node,
    credits: PropTypes.node,
    isInContent: PropTypes.bool,
    isFullscreen: PropTypes.bool,
    withSideIndents: PropTypes.bool,
    isMobile: PropTypes.bool,
    totalCount: PropTypes.number,
    theme: themePropTypes(`
    {
      texts: {
        lead: {
          font,
        }
      },
      colors: {
        content
      },
      controls: {
          gallery: {
            captions: {
              padding,
            },

            fullscreen: {
              imageInfo: {
                background,
                faderTransparency,
              }
            }
          },
        },
    }
  `),
  };

  state = {
    height: 120,
  };

  containerRef = createRef();
  minHeight = 120;
  bottomFaderHeight = 30;
  expanded = false;

  updateHeight = height => this.setState({ height });

  handleTouchStart = ({ targetTouches }) => {
    if (targetTouches.length !== 1) return;
    const containerNode = this.containerRef.current;
    const contentNode = containerNode.childNodes[0];
    if (!contentNode) return;
    const {
      height: childHeight,
    } = contentNode.getBoundingClientRect();
    this.updateHeight(this.expanded ? this.minHeight : childHeight + this.bottomFaderHeight);
    this.expanded = !this.expanded;
  };


  render() {
    const {
      caption,
      credits,
      isInContent,
      isFullscreen,
      withSideIndents,
      isMobile,
      theme,
      totalCount,
      ...otherProps
    } = this.props;

    const captionStyles = {
      color: theme.colors.content,
      font: theme.texts.lead.font,
    };

    const captions = (
      <CaptionCredits {...{
        caption,
        credits,
        ...isInContent && { captionStyles, position: 'center' },
        ...!isInContent && { creditsBefore: '&copy;', position: 'left' },
        ...otherProps,
      }}
      />
    );

    if (isFullscreen) {
      const {
        background,
        faderTransparency,
      } = theme.controls.gallery.fullscreen.imageInfo;

      return (
        <div
          ref={this.containerRef}
          className={cx(
            styles.container,
            styles.fullscreen,
            isInContent && styles.inContent,
          )}
          {...isMobile && {
            onTouchStart: this.handleTouchStart,
          }}
        >
          <style jsx>{`
            :global(.mobile) .${styles.container}
              height ${this.state.height}px
              background ${background}
              padding 10px 20px ${this.bottomFaderHeight}px 20px
              &:after
                height ${this.bottomFaderHeight}px
                background linear-gradient(${faderTransparency}, ${theme.colors.content})
          `}</style>
          {captions}
        </div>
      );
    }
    const InfoWrapper = withSideIndents ? TopicContentMaxWidth : EmptyWrapper;

    return (
      <InfoWrapper>
        <style jsx>{`
          .${styles.container}
            padding ${theme.controls.gallery.info.padding}
          .captions
            padding ${theme.controls.gallery.captions.padding}
        `}</style>
        <div className={cx(styles.container, isInContent && styles.inContent)}>
          {totalCount && (
            <Desktop>
              <div className={styles.totalCount}>
                <Camera />
                <span className={styles.count}>{totalCount}</span>
              </div>
            </Desktop>
          )}
          <div className='captions'>
            {captions}
          </div>
        </div>
      </InfoWrapper>
    );
  }
}

export default withBreakpoint(withTheme(ImageInfo));
